"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function checkOverflow(_ref, direction) {
  var offsetWidth = _ref.offsetWidth,
      scrollWidth = _ref.scrollWidth,
      offsetHeights = _ref.offsetHeights,
      scrollHeights = _ref.scrollHeights;

  if (!offsetWidth) {
    return false;
  }

  switch (direction) {
    case 'x':
      return offsetWidth < scrollWidth;

    case 'y':
      return offsetHeights < scrollHeights;

    case 'xy':
      return offsetWidth < scrollWidth && offsetHeights < scrollHeights;

    default:
      return false;
  }
}

var _default = checkOverflow;
exports.default = _default;